import { RootState } from "src/store/store";

export namespace SignOutSelector {

  export const isValidAuth = (state: RootState) => state.auth.isValidAuth;
}